import { http } from "msw";
import {
  postToken,
  postRefresh,
  getTerms,
  postAcceptTerms,
  getConversations,
  getMessages,
  postChatMessage,
  postFeedback,
  postRephrase,
  postNewChat,
  getUserInfo,
  postAskGpcChatMessage,
  getModels,
} from "./api";

export const handlers = [
  http.post(`*/v2/token`, postToken),
  http.post(`*/v2/refresh`, postRefresh),
  http.get(`*/v2/userinfo`, getUserInfo),
  http.post(`*/v2/terms`, getTerms),
  http.post(`*/v2/terms/accept`, postAcceptTerms),
  http.get(`*/v2/chat/conversations`, getConversations),
  http.get(`*/v2/chat/conversations/:chat_id/messages`, getMessages),
  http.post(`*/v2/enhanced/chat`, postChatMessage),
  http.post("*/v2/enhanced/chat/new", postNewChat),
  http.post(`*/v2/feedback`, postFeedback),
  http.post(`*/v2/chat/rephrase`, postRephrase),
  http.post("*/v2/askgpc/chat", postAskGpcChatMessage),
  http.get(`*/v2/models`, getModels),
];
